import UtilizationDonutChart from "./UtilizationDonutChart";

export default UtilizationDonutChart;
